import axios from 'axios'

export function uploadCoverImage(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function createActivity(data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            }
        })

    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            }
        })
    }
}

export function getActivity(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}


export function getActivityPage(pageId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })

    }else{
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function getActivities(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[my-activities]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getActivitiesWorkflow(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?sort=title&filter[is-booster]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getOpenActivitiesWorkflow(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?sort=title&filter[is-booster]=true&filter[is-open]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getActivitiesSharedWhitMe(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[shared-activities]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getSharedActivities(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[shared-activities]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function updateActivity(activityId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityPages(activityId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/activity-feed-items?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })

    }else{
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/activity-feed-items', {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function createActivityPage(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateActivityPage(pageId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

//delete page call
export function deleteActivityPage(pageId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function createActivityPageDraft(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/drafts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateActivityPageDraft(draftId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/drafts/' + draftId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityPageDraft(draftId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/drafts/' + draftId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function discardPageDraft(draftId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/drafts/' + draftId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function markActivityPageAsStarted(pageId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/started', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function markActivityPageAsFinished(pageId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/finished', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateActivitySection(sectionId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sections/' + sectionId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

// Get activities sharing setting options
export function getSharingSetings() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sharing-settings/', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function deleteActivitySection(sectionId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sections/' + sectionId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function createActivitySection(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sections', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function reorderActivityFeedItems(activityId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/reorder-activity-feed-items', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function checkUserInActivity(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/check-activity-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function checkUserInSpace(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/check-independent-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function shareActivity(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/share-activity', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addActivityBoosters(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/add-boosters', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getPeopleInActivity(activityId, page, size) {
    if(size){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[regular-members]=true', {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
    
}

export function getBoostersInActivity(activityId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[boosters]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getBoostersInActivityAsMember(activityId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-boosters-as-member?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeUserFromActivity(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/remove-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function removeUsersFromActivity(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/remove-users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function uploadImageInActivityPage(pageId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function changeImageInActivityPage(pageId, data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/file-check?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/file-check', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
    
}

export function createActivityQuiz(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getActivityQuiz(quizId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function addQuestionsInActivityQuiz(quizId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/add-questions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getQuestionTypesInActivityQuiz() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/question-types/', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function uploadImageInActivityQuiz(quizId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function updateActivityQuiz(quizId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityQuizQuestions(quizId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/questions?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/questions', {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function getImageURLsInActivityQuiz(quizId, data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/file-check?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/file-check', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}
export function deleteActivityQuiz(quizId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function getQuizQuestions(quizId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/get-questions', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function quizAttempt(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quiz-attempts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getQuestion(qustionId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/questions/' + qustionId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/questions/' + qustionId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function questionAnswer(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/question-attempts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function completeActivityQuiz(quizAttemptId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quiz-attempts/' + quizAttemptId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addActivityScorm(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function uploadScormPackage(scormId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms/' + scormId + '/-actions/upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function getActivityScorm(scormId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms/' + scormId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })

    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms/' + scormId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })

    }
}

export function updateActivityScorm(scormId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms/' + scormId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function uploadDocumentInActivityPage(pageId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/doc-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function changeDocumentInActivityPage(pageId, data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/doc-check?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/doc-check', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function deleteActivityScorm(scormId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/scorms/' + scormId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function getActivityPagesStats(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/page-stats', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityPagesTotalStats(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/with-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityQuestionsStats(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/question-stats', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function quizAttemptDetails(quizId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/quizzes/' + quizId + '/-actions/attempt-details', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function setActivityRule(itemId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-feed-items/' + itemId + '/-actions/lock-item', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function duplicateActivity(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/duplicate', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function occupyFeedEditor(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/feed-edits/', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function releaseFeedEditor(feedId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/feed-edits/' + feedId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getActivityEditors(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/feed-edits?activity=' + activityId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createActivityChecklist(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function uploadChecklistCoverImage(data, checklistId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function updateActivityChecklist(checklistId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityChecklist(checklistId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function uploadImageInChecklist(checklistId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function changeImageInChecklist(checklistId, data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/file-check?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/file-check', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function updateChecklistItemsInActivityChecklist(checklistId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/add-checkitems', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getChecklistItemsAll(checklistId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/checkitems?filter[booster-view]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getChecklistItems(checklistId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/checkitems?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/checkitems', {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function discardChecklistDraft(checklistId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/discard-draft', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createActivityForumThread(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/threads?withCount=comments&withUsersCount=true', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function searchPeopleInActivity(activityId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?page[size]=500&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getThreadsForActivity(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/threads?withCount=comments&withUsersCount=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function deleteActivityChecklist(checklistId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function checkitemAttempt(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checkitem-attempts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getActivityCheckitemStats(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/checkitem-stats', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function resetChecklist(checklistId) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/checklists/' + checklistId + '/-actions/reset-list', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getAllActivities(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&sort=title', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
//get activities for the search in the Dashboard
export function searchActivitiesDashborad(spaceID, size, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&filter[keyword]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function uploadAudioInActivityPage(pageId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-pages/' + pageId + '/-actions/audio-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function checkUserBatch(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/check-email-batch', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createTemplate(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/duplicate-as-template', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getTemplates(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?filter[templates]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function deleteTemplate(templateId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + templateId + '/-actions/delete-template', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function getPublicTemplates() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities?filter[publicTemplates]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function downloadActivityPeopleData(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/download-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function setPermissions(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/extra-permissions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }

    })
}
export function searchPeopleInActivityBoosters(activityId, searchTerm, page, size, ) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[boosters]=true&page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm + '&filter[include-me]=1', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchPeopleInActivityMembers(activityId, searchTerm, page, size, ) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm + '&filter[include-me]=1', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function duplicateFeedItemActivity(itemId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-feed-items/' + itemId + '/-actions/duplicate', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getCeftificateCompletionDate(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/user-activities', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createActivitySurvey(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function updateActivitySurvey(surveyId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivitySurvey(surveyId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}
export function getOverviewSurveySelection(surveyId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/stats', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function deleteActivitySurvey(surveyId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function addQuestionsInActivitySurvey(surveyId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/add-questions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getQuestionTypesInActivitySurvey() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/survey-question-types/', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })

}

export function uploadImageInSurvey(surveyId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function getSurveyQuestions(surveyId, spaceId = null) {
    if(spaceId){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/survey-questions?space-id=' + spaceId, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })

    }else{
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/survey-questions', {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function getImageURLsInActivitySurvey(surveyId, data, spaceId = null) {
    if(spaceId){
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/file-check?space-id=' + spaceId, data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/file-check', data, {
            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function getEduAdminCourseTemplates(integrationId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/eduadmins/' + integrationId + '/-actions/get-course-templates', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getCourseTemplateEvents(integrationId, courseTemplateId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/eduadmins/' + integrationId + '/-actions/template?CourseTemplateId=' + courseTemplateId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function connectActivityWithEduAdmin(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/connect-template-event', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getEduAdminConnections(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/eduadmin-connections', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSurveysInActivity(activityId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/surveys?filter[published]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function submitSurvey(surveyId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/submit-survey', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function uploadFileSurvey(surveyId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/attachment', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeFileSurvey(surveyId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/-actions/remove-file', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getAttemptsInSurvey(surveyId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/surveys/' + surveyId + '/survey-attempts?filter[completed]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getIndividualAnswers(attemptId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/survey-attempts/' + attemptId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getUserActivityAccess(spaceID, page, size, userID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&filter[access-for-user]=' + userID, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getUserActivityAccessWithRoleFilter(spaceID, page, size, userID, role) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?page[size]=' + size + '&page[number]=' + page + '&filter[access-for-user]=' + userID + '&filter-by-role=' + role, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function startAttemptInSurvey(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/survey-attempts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchActivitiesIsBooster(spaceID, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?filter[is-booster]=true&filter[keyword]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getActivitiesIsBooster(spaceID, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/activities?filter[is-booster]=true&page[size]=' + size, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function shareTemplate(activityId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + activityId + '/-actions/share-as-template', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getSpacesTemplateSharedWith(templateId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activities/' + templateId + '/shared-to-spaces', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createRequestToBecomeOwner(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getRequestToBecomeOwner(requestId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/' + requestId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function updateRequestToBecomeOwner(requestId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/' + requestId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getCertificates(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/-actions/my-certificates?sort=-updated_at', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getTags(spaceId, keyword = '') {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/tags',
        {
          params: {
            'filter[name]': keyword,
            sort: 'name',
          },
          headers: {
            'Content-Type': 'application/vnd.api+json',
          }
        }
      );
}

export function getUserTags(spaceId, userId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/user-tags?filter[user_id]=' + userId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}


export function shareItemWithUser(spaceID, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/-actions/share-items/', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getActivityReminderRules(activityId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-reminder-rules?filter[activity]=' + activityId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function createActivityReminderRule(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-reminder-rules', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function deleteActivityReminderRule(ruleId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/activity-reminder-rules/' + ruleId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
        },
    })
}